module.exports = __webpack_public_path__ + "static/media/team.b0366e54.svg";